<script setup></script>

<template>
    <a
        target="_top"
        href="/"
        class="inline-flex items-center space-x-2 hover:no-underline"
    >
        <img
            src="/img/logotype/RBR-RoadbookRally-navigation-events.png"
            alt="RBR Roadbook Rally - Navigation events - roadbooks - gpx"
        />
    </a>
</template>
